import React, { useState, useEffect } from "react";
import { Container, HeaderContainer } from "./styles";
import { Table, Tag, Tooltip, Select } from "antd";
import { CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

// Helper para Tags Vivas e Maiores
const VividTag = ({ color, children, icon }) => (
  <Tag 
    color={color} 
    icon={icon}
    style={{ 
        padding: '6px 14px', 
        fontSize: '14px', 
        fontWeight: '600', 
        borderRadius: '6px',
        border: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px'
    }}
  >
    {children}
  </Tag>
);

const generateMockPayments = (count) => {
  const statuses = ["Approved", "Pending", "Cancelled"];
  const plans = ["Mensal", "Semestral", "Anual"];
  const types = ["Compra", "Renovação"];
  const data = [];
  
  for (let i = 1; i <= count; i++) {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    data.push({
      key: i,
      id: i,
      user: `Usuário Cliente ${i}`,
      email: `cliente${i}@email.com`,
      plan: plans[Math.floor(Math.random() * plans.length)],
      amount: `R$ ${(Math.random() * 200 + 50).toFixed(2).replace('.', ',')}`,
      date: new Date(2025, 0, Math.floor(Math.random() * 30) + 1).toLocaleDateString('pt-BR'),
      status: status,
      type: types[Math.floor(Math.random() * types.length)],
    });
  }
  return data;
};

export default function Payments() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setData(generateMockPayments(50));
      setLoading(false);
    }, 600);
  }, []);

  const filteredData = statusFilter 
    ? data.filter(item => item.status === statusFilter) 
    : data;

  const columns = [
    {
      title: "Usuário",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <div>
            <div style={{ fontWeight: 'bold' }}>{text}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>{record.email}</div>
        </div>
      )
    },
    {
      title: "Plano",
      dataIndex: "plan",
      key: "plan",
      render: (plan) => (
        <VividTag color="#108ee9">
            {plan}
        </VividTag>
      )
    },
    {
        title: "Tipo",
        dataIndex: "type",
        key: "type",
        render: (type) => (
          <Tag color={type === "Renovação" ? "purple" : "blue"} style={{ fontWeight: 600 }}>
              {type}
          </Tag>
        )
    },
    {
      title: "Valor",
      dataIndex: "amount",
      key: "amount",
      render: (val) => <strong>{val}</strong>
    },
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "#87d068"; // Default Green
        let icon = <CheckCircleOutlined />;
        
        if (status === "Pending") {
            color = "#faad14"; // Orange
            icon = <SyncOutlined spin />;
        }
        if (status === "Cancelled") {
            color = "#ff4d4f"; // Red
            icon = <CloseCircleOutlined />;
        }

        const label = status === "Approved" ? "Aprovado" : status === "Pending" ? "Pendente" : "Cancelado";

        return (
          <VividTag color={color} icon={icon}>
            {label.toUpperCase()}
          </VividTag>
        );
      },
    },
  ];

  const totalSales = filteredData.reduce((acc, curr) => {
     // Simple parse for mock data "R$ 100,00" -> 100.00
     const val = parseFloat(curr.amount.replace('R$ ', '').replace(',', '.'));
     return acc + (curr.status === 'Approved' ? val : 0);
  }, 0);

  return (
    <Container>
      <HeaderContainer>
        <h1>Histórico de Pagamentos</h1>
        <div className="actions-container">
            <VividTag color="#008037">
                Receita Total: {totalSales.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </VividTag>
            
            <Select 
                placeholder="Filtrar Status" 
                style={{ width: 180 }} 
                allowClear
                size="large"
                onChange={(val) => setStatusFilter(val)}
            >
                <Option value="Approved">Aprovado</Option>
                <Option value="Pending">Pendente</Option>
                <Option value="Cancelled">Cancelado</Option>
            </Select>
        </div>
      </HeaderContainer>

      <Table 
        columns={columns} 
        dataSource={filteredData} 
        loading={loading}
        pagination={{ position: ['bottomCenter'], pageSize: 10 }}
        rowKey="id"
      />
    </Container>
  );
}
